import IconBullet from "@/components/icons/IconBullet.vue";
import IconPriorityHigh from "@/components/icons/priorities/IconPriorityHigh.vue";
import IconPriorityHighest from "@/components/icons/priorities/IconPriorityHighest.vue";
import IconPriorityLow from "@/components/icons/priorities/IconPriorityLow.vue";
import IconPriorityLowest from "@/components/icons/priorities/IconPriorityLowest.vue";
import IconPriorityMedium from "@/components/icons/priorities/IconPriorityMedium.vue";

export const prioritiesIconsMap = {
  highest: {
    icon: IconPriorityHighest,
    class: "text-red-500",
    viewBox: "-1 0 15 12",
  },
  high: {
    icon: IconPriorityHigh,
    class: "text-red-500",
    viewBox: "-1 -3 15 12",
  },
  medium: {
    icon: IconPriorityMedium,
    class: "text-yellow-500",
    viewBox: "-1 0 15 12",
  },
  low: {
    icon: IconPriorityLow,
    class: "text-primary",
    viewBox: "-1.5 0 15 12",
  },
  lowest: {
    icon: IconPriorityLowest,
    class: "text-primary",
    viewBox: "-1.5 -3 15 15",
  },
  none: {
    icon: IconBullet,
    class: "",
    viewBox: "-8 -8 25 25",
  },
};

export const priorities = [
  {
    value: "highest",
    icon: IconPriorityHighest,
    viewBox: "-1 0 15 12",
    class: "text-red-500",
  },
  {
    value: "high",
    icon: IconPriorityHigh,
    viewBox: "-1 -3 15 12",
    class: "text-red-500",
  },
  {
    value: "medium",
    icon: IconPriorityMedium,
    viewBox: "-1 0 15 12",
    class: "text-yellow-500",
  },
  {
    value: "low",
    icon: IconPriorityLow,
    viewBox: "-1.5 0 15 12",
    class: "text-primary",
  },
  {
    value: "lowest",
    icon: IconPriorityLowest,
    viewBox: "-1.5 -3 15 15",
    class: "text-blue-500",
  },
];
